import { useEffect, useState } from "react";
import { CheckCircle2, X } from "lucide-react";

const EVENTS = [
  { city: "Mumbai", action: "booked a free audit" },
  { city: "Bangalore", action: "started Amazon onboarding" },
  { city: "Delhi", action: "booked a consultation" },
  { city: "Pune", action: "completed the readiness quiz" },
  { city: "Hyderabad", action: "started Flipkart onboarding" },
  { city: "Ahmedabad", action: "requested a Nykaa launch plan" },
  { city: "Jaipur", action: "booked a Blinkit strategy call" },
  { city: "Kolkata", action: "joined the JioMart waitlist" },
  { city: "Chennai", action: "started Meesho launch" },
  { city: "Surat", action: "booked an account-health audit" },
];

const MINUTES = ["2 minutes ago", "4 minutes ago", "6 minutes ago", "just now", "8 minutes ago"];

function pick(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

export default function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [event, setEvent] = useState(null);

  useEffect(() => {
    let timer;
    let hideTimer;
    let cancelled = false;

    const show = () => {
      if (cancelled) return;
      setEvent({
        location: pick(EVENTS),
        when: pick(MINUTES),
      });
      setVisible(true);
      hideTimer = setTimeout(() => setVisible(false), 6000); // visible 6s
      timer = setTimeout(show, 65000); // next one in ~65s
    };

    // First popup after 15s
    timer = setTimeout(show, 15000);

    return () => {
      cancelled = true;
      clearTimeout(timer);
      clearTimeout(hideTimer);
    };
  }, []);

  if (!event) return null;

  return (
    <div
      data-testid="social-proof-popup"
      className={`fixed bottom-[13.5rem] left-4 z-40 w-[calc(100vw-2rem)] max-w-xs border-2 border-black bg-white shadow-brutal transition-all duration-300 lg:bottom-6 lg:left-24 ${
        visible ? "translate-y-0 opacity-100" : "pointer-events-none translate-y-3 opacity-0"
      }`}
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center gap-3 p-3">
        <div className="flex h-9 w-9 shrink-0 items-center justify-center border-2 border-black bg-[#FFD700]">
          <CheckCircle2 size={16} />
        </div>
        <div className="min-w-0 flex-1 leading-tight">
          <div className="text-xs font-bold">
            A seller from <span className="text-black">{event.location.city}</span>
          </div>
          <div className="truncate text-xs text-black/70">{event.location.action}</div>
          <div className="mt-0.5 text-[10px] font-bold uppercase tracking-widest text-black/40">{event.when}</div>
        </div>
        <button
          aria-label="Dismiss"
          onClick={() => setVisible(false)}
          className="border-2 border-black bg-white p-1 hover:bg-[#FFD700]"
        >
          <X size={12} />
        </button>
      </div>
    </div>
  );
}
